import type { ICategory } from "app/common/services/categoryService.types";
import type { FC } from "react";
import { useState } from "react";
import type { ISegmentsModule } from "app/services/segments/segmentsApiService";
import { useSelector } from "react-redux";
import { allTrackers } from "app/services/track/track";
import { FadeWrapper } from "app/pages/industry-analysis/home/StyledComponents";
import { SpinnerLoader } from "pro-features/components/Loaders/src/Spinner";
import { EditContextMenu } from "app/pages/industry-analysis/home/EditContextMenu";

interface ICustomIndustryItem {
    industry: ICategory;
    onEdit: VoidFunction;
    onShare: VoidFunction;
    onDelete: VoidFunction;
}

const TRACKING_MD = {
    edit: "Edit Category",
    share: "Share custom industry",
    delete: "Delete custom industry",
};

type TrackingMD = typeof TRACKING_MD;

export const CustomIndustryItem: FC<ICustomIndustryItem> = (props) => {
    const { industry, onDelete, onShare, onEdit } = props;
    const { categoryId } = industry;
    const [isEditOpen, setIsEditOpen] = useState<boolean>(false);
    const segmentsModule: ISegmentsModule = useSelector((state) => {
        const { segmentsModule } = state;
        return segmentsModule;
    });
    const { segmentsLoading } = segmentsModule;
    const onEditToggle = (isOpen) => {
        if (isOpen) {
            allTrackers.trackEvent("Button", "click", "Custom industry menu");
        }
        setIsEditOpen(isOpen);
    };
    const withTracking = (action: VoidFunction, actionType: keyof TrackingMD) => () => {
        allTrackers.trackEvent("Pop Up", "open", TRACKING_MD[actionType]);
        action();
    };
    return (
        <FadeWrapper
            key={`editIcon-${categoryId}`}
            opacity={isEditOpen ? 1 : 0}
            onClick={(event) => {
                event.stopPropagation();
                return false;
            }}
        >
            {segmentsLoading ? (
                <SpinnerLoader />
            ) : (
                <EditContextMenu
                    onEdit={withTracking(onEdit, "edit")}
                    onDelete={withTracking(onDelete, "delete")}
                    onShare={withTracking(onShare, "share")}
                    onToggle={onEditToggle}
                />
            )}
        </FadeWrapper>
    );
};
